import React from 'react';
// Raw Material SVG icon components (fill='currentColor', no theme dependency) so
// they render standalone inside the vendor portal — matching the real icons the
// rest of the panel uses, instead of emoji.
// @ts-ignore
import Dashboard from '../../components/icon/material-icons/Dashboard';
// @ts-ignore
import Assignment from '../../components/icon/material-icons/Assignment';
// @ts-ignore
import Description from '../../components/icon/material-icons/Description';
// @ts-ignore
import ReceiptLong from '../../components/icon/material-icons/ReceiptLong';
// @ts-ignore
import Receipt from '../../components/icon/material-icons/Receipt';
// @ts-ignore
import Person from '../../components/icon/material-icons/Person';
// @ts-ignore
import Lock from '../../components/icon/material-icons/Lock';
// @ts-ignore
import Visibility from '../../components/icon/material-icons/Visibility';
// @ts-ignore
import VisibilityOff from '../../components/icon/material-icons/VisibilityOff';
// @ts-ignore
import CheckCircle from '../../components/icon/material-icons/CheckCircle';
// @ts-ignore
import Cancel from '../../components/icon/material-icons/Cancel';
// @ts-ignore
import HourglassEmpty from '../../components/icon/material-icons/HourglassEmpty';
// @ts-ignore
import EmojiEvents from '../../components/icon/material-icons/EmojiEvents';
// @ts-ignore
import Inventory from '../../components/icon/material-icons/Inventory';
// @ts-ignore
import Article from '../../components/icon/material-icons/Article';
// @ts-ignore
import AttachFile from '../../components/icon/material-icons/AttachFile';
// @ts-ignore
import Search from '../../components/icon/material-icons/Search';
// @ts-ignore
import ChevronLeft from '../../components/icon/material-icons/ChevronLeft';
// @ts-ignore
import ChevronRight from '../../components/icon/material-icons/ChevronRight';
// @ts-ignore
import Inbox from '../../components/icon/material-icons/Inbox';
// @ts-ignore
import Warning from '../../components/icon/material-icons/Warning';
// @ts-ignore
import TaskAlt from '../../components/icon/material-icons/TaskAlt';
// @ts-ignore
import LinkOff from '../../components/icon/material-icons/LinkOff';
// @ts-ignore
import Logout from '../../components/icon/material-icons/Logout';
// @ts-ignore
import ShoppingCart from '../../components/icon/material-icons/ShoppingCart';

const MAP: Record<string, React.ComponentType<any>> = {
	dashboard: Dashboard,
	requisitions: Assignment,
	quotations: Description,
	challans: ReceiptLong,
	receipt: Receipt,
	profile: Person,
	lock: Lock,
	show: Visibility,
	hide: VisibilityOff,
	accepted: CheckCircle,
	rejected: Cancel,
	pending: HourglassEmpty,
	celebrate: EmojiEvents,
	uploads: Inventory,
	document: Article,
	attach: AttachFile,
	search: Search,
	prev: ChevronLeft,
	next: ChevronRight,
	empty: Inbox,
	warning: Warning,
	check: TaskAlt,
	unlink: LinkOff,
	logout: Logout,
	purchaseOrders: ShoppingCart,
};

export type VpIconName = keyof typeof MAP;

const VpIcon = ({
	name,
	size = 18,
	color,
	className,
	style,
}: {
	name: VpIconName | string;
	size?: number;
	color?: string;
	className?: string;
	style?: React.CSSProperties;
}) => {
	const Cmp = MAP[name] || Article;
	return (
		<Cmp
			width={size}
			height={size}
			className={className}
			style={{ color, verticalAlign: 'middle', flex: 'none', ...style }}
		/>
	);
};

export default VpIcon;
